import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ComputerTagsFacade } from 'mbs-ui-shared@facades/computer.tags.facade';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective, SmartSearchState } from 'mbs-ui-kit';
import { map } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';

@Component({
  selector: 'mbs-smart-search-tags-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchTagsTemplateComponent) }]
})
export class SmartSearchTagsTemplateComponent extends SmartSearchBaseTemplateComponent {
  public tag = SmartSearchTemplateName.Tag;
  constructor(public i18nPipe: I18NextPipe, public tagsFacade: ComputerTagsFacade) {
    super(i18nPipe);
  }
  public items = (state: SmartSearchState) =>
    this.tagsFacade.loadAllTags().pipe(
      map((values) =>
        values
          .filter((value) => (value.name ?? '').toLowerCase().includes((state.leftCaretClearValue ?? '').toLowerCase()))
          .map((value) => ({
            value: value.name,
            searchText: value.name,
            translation: null
          }))
      )
    );
}
